import { grey } from '@platform/front-ui';

export const mainBorder = `1px solid ${grey[200]}`;
